import { Grid, Skeleton } from '@mui/material';

const SeasonEpisodesListSkeleton = () => {
  return (
    <Grid container direction="column" rowGap={1}>
      {Array.from({ length: 5 }).map((_, index) => (
        <Grid item key={`season-episode-item-${index}`} component={Skeleton} variant="rounded" height={50} />
      ))}
    </Grid>
  );
};

export default SeasonEpisodesListSkeleton;
